import {
    GET_FACULTIES_FAIL,
    GET_FACULTIES_SUCCESS,
    ADD_FACULTY_SUCCESS,
    ADD_FACULTY_FAIL,
    UPDATE_FACULTY_SUCCESS,
    UPDATE_FACULTY_FAIL,
    DELETE_FACULTY_SUCCESS,
    DELETE_FACULTY_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    faculties: [],
    error: null,
    loading: true
};

const facultyReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des faculties
        case GET_FACULTIES_SUCCESS:
            return {
                ...state,
                faculties: action.payload, // tableau d'objets faculty
                loading: false,
                error: null
            };

        case GET_FACULTIES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une facultye
        case ADD_FACULTY_SUCCESS:
            return {
                ...state,
                faculties: [action.payload, ...state.faculties], // ajoute au début du tableau
                error: null
            };

        case ADD_FACULTY_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une facultye
        case UPDATE_FACULTY_SUCCESS:
            return {
                ...state,
                faculties: state.faculties.map(faculty =>
                    faculty.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet faculty
                        : faculty
                ),
                error: null
            };

        case UPDATE_FACULTY_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une facultye
        case DELETE_FACULTY_SUCCESS:
            return {
                ...state,
                faculties: state.faculties.filter(
                    faculty => faculty.id !== action.payload
                ),
                error: null
            };


        case DELETE_FACULTY_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default facultyReducer;
